<div>
	<ul class="nav nav-tabs">
		<li
			*ngFor="let tab of tabs"
			(click)="selectTab(tab)"
			[class.active]="tab.active"
		>
			<a>
				<ng-container *ngIf="tab.titleTemplate; else plainTitle">
					<ng-container *ngTemplateOutlet="tab.titleTemplate"></ng-container>
				</ng-container>
				<ng-template #plainTitle>{{ tab.title }}</ng-template>
			</a>
		</li>
	</ul>
	<ng-content></ng-content>
</div>
